import { createContext, useContext } from "react";
import { z } from "zod";

type AnyZodObject = z.ZodObject<any> | z.ZodEffects<any>;

const SchemaContext = createContext<AnyZodObject | null>(null);

export function SchemaProvider({
    schema,
    children,
}: {
    schema: AnyZodObject;
    children: React.ReactNode;
}) {
    return (
        <SchemaContext.Provider value={schema}>
            {children}
        </SchemaContext.Provider>
    );
}

export function useSchema() {
    const schema = useContext(SchemaContext);
    if (!schema) {
        throw new Error("useSchema must be used inside SchemaProvider");
    }
    return schema;
}
